// AddDriver.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl } from "../Univ";

function AddDriver() {
  const [drivers, setDrivers] = useState([]);
  const [form, setForm] = useState({
    username: "",
    email: "",
    phone: "",
    address: "",
    latitude: "",
    longitude: "",
    vehicle_number: "",
    vehicle_type: "bike",
  });

  const fetchDrivers = () => {
    axios
      .get(baseUrl + "drivers/")
      .then((res) => setDrivers(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitDriver = (e) => {
    e.preventDefault();
    axios
      .post(baseUrl + "drivers/add/", form)
      .then((res) => {
        Swal.fire("Driver Added!", "", "success");
        setForm({ username: "", email: "", phone: "", vehicle_number: "", vehicle_type: "bike", address: "", latitude: "", longitude: "" });
        fetchDrivers();
      })
      .catch((err) => {
        console.error(err);
        Swal.fire("Error", "Failed to add driver", "error");
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete driver?",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(baseUrl + `drivers/delete/${id}/`)
          .then(() => {
            Swal.fire("Deleted", "", "success");
            fetchDrivers();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "username", headerName: "Username", width: 130 },
    { field: "email", headerName: "Email", width: 180 },
    { field: "phone", headerName: "Phone", width: 120 },
    { field: "vehicle_number", headerName: "Vehicle", width: 130 },
    { field: "vehicle_type", headerName: "Type", width: 100 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(params.row.id)}>
          Delete
        </button>
      ),
    },
  ];
const getLocation = () => {

    if (!navigator.geolocation) {
      Swal.fire("Error", "GPS not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {

        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );

          setForm({
            ...form,
            latitude: lat,
            longitude: lon,
            address: res.data.display_name
          });

          Swal.fire("Success", "Address fetched successfully", "success");

        } catch {
          Swal.fire("Error", "Failed to fetch address", "error");
        }
      },
      () => Swal.fire("Error", "Location permission denied", "error")
    );
  };

  return (
    <div className="container mt-4">
      <div className="card mb-4">
        <h4 className="card-header">Add Driver</h4>
        <div className="card-body">
          <form onSubmit={submitDriver}>
            <input name="username" placeholder="Username" className="form-control mb-2" onChange={handleChange} required />
            <input name="email" placeholder="Email" className="form-control mb-2" onChange={handleChange} required />
            <input name="phone" placeholder="Phone" className="form-control mb-2" onChange={handleChange} required />
            <input name="vehicle_number" placeholder="Vehicle Number" className="form-control mb-2" onChange={handleChange} required />
            <select name="vehicle_type" className="form-control mb-2" value={form.vehicle_type} onChange={handleChange}>
              <option value="bike">Bike</option>
              <option value="car">Car</option>
              <option value="van">Van</option>
            </select>

                  <textarea
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    placeholder="Type address or use GPS"
                  />

                  <button
                    type="button"
                    className="btn btn-info ms-2"
                    onClick={getLocation}
                  >
                    <i className="fa-solid fa-location-dot"></i>
                  </button>

            <button className="btn btn-success w-100">Add Driver</button>
          </form>
        </div>
      </div>

      <div style={{ height: "400px", width: "100%" }}>
        <DataGrid
        sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
          rows={drivers}
          columns={columns}
          autoHeight
          pageSize={10}
          components={{ Toolbar: GridToolbar }}
        />
      </div>
    </div>
  );
}

export default AddDriver;
